
'use strict';
(function(angular) {
  // Declare 'Activation' app level module which depends on filters, and services
  var actApp = angular
  //Define the requirements
    .module('activationApp', ['ngRoute',
      'ngCookies',
      'ui.router',
      'ui.bootstrap',
      'payment',
      'payment.tpls',
      'activationApp.filters',
      'activationApp.services',
      'activationApp.directives',
      'activationApp.controllers',
      'fetch-web-angular',
      'fetchtv.Directives',
      'fetchtv.services',
      'fetchtv.controllers',
      'vcRecaptcha'
    ]);

  actApp.config(['$stateProvider',
    '$urlRouterProvider',
    function($stateProvider, $urlRouterProvider) {
      $urlRouterProvider.otherwise('/welcome');

      $stateProvider
        .state('welcome', {
          url: '/welcome',
          templateUrl: 'views/activation/welcome.html',
          controller: 'WelcomeCtrl'
        });
      $stateProvider
        .state('activate', {
          abstract: true,
          url: '/activate',
          templateUrl: 'views/activation/activate.html'
        })
        .state('activate.step1', {
          url: '/step1',
          templateUrl: 'views/activation/step1.html'
        })
        .state('activate.step2', {
          url: '/step2',
          templateUrl: 'views/activation/step2.html'
        })
        .state('activate.step3', {
          url: '/step3',
          templateUrl: 'views/activation/step3.html'
        })
        .state('activate.step4', {
          url: '/step4',
          templateUrl: 'views/activation/step4.html',
          controller: 'Step4Ctrl'
        })
        .state('activate.step5', {
          url: '/step5',
          templateUrl: 'views/activation/step5.html'
        });
    }
  ])
    .value('eapik', top.eapik)
    .value('basepackid', top.basepackid)
    .value('ultimatePackId', top.ultimatePackId)
    .value('ultimatePackIntroOrdered', top.ultimatePackIntroOrdered)
    .value('ultimatePackIntroActivated', top.ultimatePackIntroActivated)
    .value('skinnyPackIds', top.skinnyPackIds)
    .value('activationbaseurl', top.activationbaseurl)
    .value('toolboxbaseurl', top.toolboxbaseurl)
    .value('proxyprefix', top.proxyprefix);

  actApp.constant('recaptchaKey', top.recaptchaKey || '6LcPvawUAAAAAH6C3zbkA0vpX3s0fPd1yDHtq65E');

  angular.module('activationApp.services', []);
  angular.module('fetchtv.Directives', []);
  angular.module('fetchtv.services', []);
  angular.module('fetchtv.controllers', []);
  angular.module('activationApp.controllers', []);
})(angular);
